import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Card } from "../ui/card";
import { Loader2, FileText, Search, Cloud } from "lucide-react";

function GoogleDriveModal({ 
  isOpen, 
  onClose, 
  files, 
  isLoading, 
  onLoadFile,
  onSearch,
  driveConnected,
  onConnect
}) {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = () => {
    onSearch(searchQuery);
  };

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl bg-[#1a1a2e] border-white/10">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-white">
            Load from Google Drive
          </DialogTitle>
        </DialogHeader>

        <div className="mt-4">
          {!driveConnected ? (
            <div className="text-center py-12">
              <Cloud className="w-16 h-16 mx-auto mb-4 text-blue-400 opacity-50" />
              <p className="text-white/80 mb-4">Connect your Google Drive to load documents</p>
              <Button
                onClick={onConnect}
                className="bg-blue-500 hover:bg-blue-600 text-white"
              >
                <Cloud className="w-4 h-4 mr-2" />
                Connect Google Drive
              </Button>
            </div>
          ) : (
            <>
              {/* Search */}
              <div className="flex gap-2 mb-4">
                <Input
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search files..."
                  onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                  className="bg-white/5 border-white/10 text-white"
                />
                <Button
                  onClick={handleSearch}
                  variant="outline"
                  disabled={isLoading}
                >
                  <Search className="w-4 h-4" />
                </Button>
              </div>

              {/* Files List */}
              {isLoading ? (
                <div className="flex items-center justify-center py-12">
                  <Loader2 className="w-8 h-8 animate-spin text-[#00d4aa]" />
                </div>
              ) : files.length === 0 ? (
                <div className="text-center py-12 text-white/60">
                  <FileText className="w-12 h-12 mx-auto mb-4 opacity-50" />
                  <p>No documents found.</p>
                  <p className="text-sm mt-2">Try a different search or create a Google Doc first.</p>
                </div>
              ) : (
                <div className="space-y-2 max-h-[400px] overflow-y-auto pr-2">
                  {files.map((file) => (
                    <Card
                      key={file.id}
                      className="card cursor-pointer hover:border-[#00d4aa]/50 transition-all"
                      onClick={() => onLoadFile(file.id, file.name)}
                    >
                      <div className="p-3">
                        <div className="flex items-center justify-between gap-4">
                          <div className="flex items-center gap-3 flex-1">
                            <FileText className="w-5 h-5 text-blue-400" />
                            <div className="flex-1">
                              <p className="font-medium text-white">{file.name}</p>
                              <p className="text-xs text-white/60">
                                Modified: {new Date(file.modifiedTime).toLocaleDateString()}
                              </p>
                            </div>
                          </div>
                          <Button
                            size="sm"
                            className="bg-[#00d4aa] hover:bg-[#00e6bb] text-black"
                            onClick={(e) => {
                              e.stopPropagation();
                              onLoadFile(file.id, file.name);
                            }}
                          >
                            Load
                          </Button>
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default GoogleDriveModal;